export const PAY_PIX = "pix";
export const PAY_BOLETO = "boleto";
export const PAY_CREDIT_CARD = "credito";

export const PAY_PIX_VIEW = "PIX";
export const PAY_BOLETO_VIEW = "Boleto";
export const PAY_CREDIT_CARD_VIEW = "Cartão de Crédito";

export const STATUS_WAITING = "AGUARDANDO";
export const STATUS_PAID = "PAGA";
export const STATUS_CANCELED = "CANCELADA";
export const STATUS_ERROR = "ERRO";
